/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum includedServiceTypeEnum {
  OTHER = 'Other',
  RAIL_AND_FLY = 'RailAndFly',
  RAIL_AND_CRUISE = 'RailAndCruise',
  TRANSFER = 'Transfer',
}
